import React from 'react';

export default ( { className, fill, ...props } ) => (
    <svg width="24" height="24" className={ className } { ...props } viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M18.25 10.24L16.83 11.66L13.01 7.85V20H11V7.85L7.18001 11.66L5.76001 10.24L12 4L18.26 10.24H18.25Z" fill={ fill || 'currentColor' } />
    </svg>
);
